(function () {
  function mountBannerEightContent() {
    var slide = document.querySelector('#shopify-section-home #anHero.hero .hero-slide:nth-child(8)');
    if (!slide) return;

    var fullLink = slide.querySelector('.hero-link');
    if (fullLink) {
      fullLink.href = '/collections/all';
      fullLink.setAttribute('aria-label', 'Shop all fragrances');
    }

    if (slide.querySelector('.an-hero-copy-layer--signature')) return;

    var scrim = document.createElement('div');
    scrim.className = 'an-hero-copy-scrim an-hero-copy-scrim--signature';
    scrim.setAttribute('aria-hidden', 'true');

    var layer = document.createElement('div');
    layer.className = 'an-hero-copy-layer an-hero-copy-layer--signature';
    layer.innerHTML = [
      '<div class="an-hero-copy an-hero-copy--signature">',
      '<h2 aria-label="Moments They\'ll Remember">',
      '<span class="an-hero-signature-line">Moments They\'ll</span>',
      '<span class="an-hero-signature-line an-hero-signature-accent">Remember</span>',
      '</h2>',
      '<p>Scents that stay long after the night is over.</p>',
      '<a class="an-hero-cta an-hero-cta--signature" href="/collections/all">Explore Signature Scents</a>',
      '</div>'
    ].join('');

    slide.appendChild(scrim);
    slide.appendChild(layer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountBannerEightContent);
  } else {
    mountBannerEightContent();
  }

  window.addEventListener('pageshow', mountBannerEightContent);
  document.addEventListener('shopify:section:load', mountBannerEightContent);
})();
